import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, VStack } from '@chakra-ui/react';
import { FounderInterviewCard } from '@src/components/sco/Education/ArticleLanding/FounderInterviewCard';
import { FadeRevealWithSSR } from '@src/components/sco/ssr-transitions/FadeRevealWithSSR';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { gql } from '@src/lib/gql';
import React from 'react';
type FounderInterviewListProps = {
  typeTitle?: string;
  typeSlug?: string;
};
export const FounderInterviewList = props => {
  const $ = _c(18);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($type: ArticleType!) {
        articles(where: { type: $type }, orderBy: publishedAt_DESC) {
          id
          title
          seoDescription
          slug
          terms {
            id
            name
            slug
            color {
              hex
            }
          }
          subjectNames
          subjectLogos {
            id
            url
          }
          featuredImage {
            id
            url(transformation: { image: { resize: { fit: max, width: 1000 } } })
            altText
            height
            width
          }
        }
      }
    `;
    t1 = {
      variables: {
        type: "FounderStory"
      }
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 6, 8, 8, 8]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== query.error) {
    t3 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[4] = query.error;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== query.loading) {
    t4 = query.loading && <Center><Spinner /></Center>;
    $[6] = query.loading;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.typeSlug || $[9] !== query.data) {
    t5 = query.data?.articles && [...query.data.articles].sort(_temp).map((article, index) => <FadeRevealWithSSR key={article.id} duration={1500} style={{
      width: "100%"
    }}><FounderInterviewCard image={article.featuredImage?.url} large={index % 3 == 2 ? true : false} subject={article.subjectNames.join(" & ")} subjectLogo={article.subjectLogos[0]?.url} summary={article.seoDescription} title={article.title} url={`/${props.typeSlug || "articles"}/${article.slug}`} /></FadeRevealWithSSR>);
    $[8] = props.typeSlug;
    $[9] = query.data;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <VStack gap={10} width="full">{t5}</VStack>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <VStack align="center" gap={t2} width="full">{t3}{t4}{t6}</VStack>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
function _temp(a, b) {
  if (b.subjectLogos[0]?.url && !a.subjectLogos[0]?.url) {
    return 1;
  }
  if (a.subjectLogos[0]?.url && !b.subjectLogos[0]?.url) {
    return -1;
  }
  return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
}